import React from 'react';
import { X, Globe } from 'lucide-react';
import { resolveGroupMembers } from '../lib/destinationGroups';

// Picker shown when a user taps a destination that belongs to an admin-defined
// group (e.g. Indonesia -> Standard / Lite / Premium). Each variant shows the
// variant label + an optional descriptor.
export const DestinationGroupModal = ({ group, allCountries, onClose, onPick }) => {
  if (!group) return null;
  const members = resolveGroupMembers(group, allCountries);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-sm p-0 sm:p-4"
      onClick={onClose}
      data-testid="destination-group-modal"
    >
      <div
        className="w-full sm:max-w-lg bg-white dark:bg-neutral-900 rounded-t-3xl sm:rounded-3xl shadow-2xl max-h-[90vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 pt-6 pb-3">
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-neutral-500">Pick a plan tier</p>
            <h2 className="text-2xl font-black text-gray-900 dark:text-neutral-100 mt-1">{group.name}</h2>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full bg-gray-100 dark:bg-neutral-800 hover:bg-gray-200 dark:hover:bg-neutral-700 flex items-center justify-center transition-colors"
            data-testid="destination-group-close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="px-4 pb-6 overflow-y-auto">
          <div className="space-y-2">
            {members.map((m) => {
              const country = m.country;
              const label = m.label || country.name;
              return (
                <button
                  key={m.country_id}
                  onClick={() => onPick(country.id)}
                  className="w-full flex items-center gap-4 p-4 rounded-2xl border-2 border-gray-100 dark:border-neutral-800 hover:border-black dark:hover:border-white hover:shadow-md transition-all text-left"
                  data-testid={`destination-group-pick-${country.id}`}
                >
                  {country.isRegion ? (
                    <div className="w-14 h-14 flex-shrink-0 rounded-xl bg-gradient-to-br from-blue-500 to-emerald-500 flex items-center justify-center">
                      <Globe size={24} className="text-white" />
                    </div>
                  ) : (
                    <img
                      src={country.image || country.flag}
                      alt={label}
                      className="w-14 h-14 flex-shrink-0 rounded-xl object-cover"
                      onError={(e) => { e.currentTarget.src = country.flag; }}
                    />
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="font-bold text-gray-900 dark:text-neutral-100 truncate">{label}</div>
                    {m.descriptor ? (
                      <div className="text-sm text-gray-500 dark:text-neutral-400 mt-0.5 line-clamp-2">{m.descriptor}</div>
                    ) : null}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DestinationGroupModal;
